module.exports = __webpack_public_path__ + "db812d8a70a4e88e888744c1c9a27e89.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./~/font-awesome/fonts/fontawesome-webfont.woff2?v=4.5.0
 ** module id = 31
 ** module chunks = 0
 **/